import React from 'react'
import { LangSteps41 } from '../../../constant/languange'
import Content from '../Content'

const Fourth1 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps41],
    button: 'Mulai Atur Jadwal Kerja',
    nextStep: 5,
    skipTo: '/attendance/spot',
    isDone: props.stats.work_and_shift_times_count
  }

  return <Content {...props} data={data} />
}

export default Fourth1
